var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAllowed
    ? _c(
        "div",
        [
          _c(
            "b-button",
            {
              attrs: { size: _vm.buttonSize, variant: "primary" },
              on: { click: _vm.openModal },
            },
            [
              _vm.isLoading
                ? _c("span", {
                    staticClass: "spinner-border spinner-border-sm",
                    attrs: { "aria-hidden": "true", role: "status" },
                  })
                : _vm._e(),
              _vm._v("\n        " + _vm._s(_vm.label) + "\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: { "hide-footer": "", size: "lg", title: _vm.label },
              model: {
                value: _vm.isModalOpen,
                callback: function ($$v) {
                  _vm.isModalOpen = $$v
                },
                expression: "isModalOpen",
              },
            },
            [
              _vm.isLoading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "loading-content-container d-flex justify-content-center",
                    },
                    [_c("csp-loading-indicator")],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "info-card editMode" },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col"),
                          _vm._v(" "),
                          _c("b-col", [_c("b", [_vm._v("GDV Ergebnis")])]),
                          _vm._v(" "),
                          _c("b-col", [_c("b", [_vm._v("Portal Wert")])]),
                          _vm._v(" "),
                          _c("b-col", [_c("b", [_vm._v("Übernahme")])]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [_vm._v("Datum des Unfalls")]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.dateOfLoss,
                                  "hide-label": true,
                                  property: "serviceValue",
                                  required: false,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.dateOfLoss,
                                  "hide-label": true,
                                  property: "recordValue",
                                  required: true,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-checkbox", {
                                attrs: {
                                  checked: false,
                                  form: _vm.dateOfLoss,
                                  "hide-label": true,
                                  "override-label": "",
                                  property: "override",
                                  "unchecked-value": "0",
                                  value: "1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [_c("span", [_vm._v(" ")])]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3280651264
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _vm._v("Kennzeichen des Unfallgegners"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.licenceNumber,
                                  "hide-label": true,
                                  property: "serviceValue",
                                  required: false,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.licenceNumber,
                                  "hide-label": true,
                                  property: "recordValue",
                                  required: true,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-checkbox", {
                                attrs: {
                                  checked: false,
                                  form: _vm.licenceNumber,
                                  "hide-label": true,
                                  "override-label": "",
                                  property: "override",
                                  "unchecked-value": "0",
                                  value: "1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [_c("span", [_vm._v(" ")])]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3280651264
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _vm._v(
                              "Versicherungsscheinnummer des Unfallgegners"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePolicyNumber,
                                  "hide-label": true,
                                  property: "serviceValue",
                                  required: false,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePolicyNumber,
                                  "hide-label": true,
                                  property: "recordValue",
                                  required: true,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-checkbox", {
                                attrs: {
                                  checked: false,
                                  form: _vm.insurancePolicyNumber,
                                  "hide-label": true,
                                  "override-label": "",
                                  property: "override",
                                  "unchecked-value": "0",
                                  value: "1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [_c("span", [_vm._v(" ")])]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3280651264
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _vm._v("Name der Versicherungsfiliale"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOName,
                                  "hide-label": true,
                                  property: "serviceValue",
                                  required: false,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOName,
                                  "hide-label": true,
                                  property: "recordValue",
                                  required: true,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-checkbox", {
                                attrs: {
                                  checked: false,
                                  form: _vm.insurancePOName,
                                  "hide-label": true,
                                  "override-label": "",
                                  property: "override",
                                  "unchecked-value": "0",
                                  value: "1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [_c("span", [_vm._v(" ")])]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3280651264
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _vm._v("Straße der Versicherungsfiliale"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOStreet,
                                  "hide-label": true,
                                  property: "serviceValue",
                                  required: false,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOStreet,
                                  "hide-label": true,
                                  property: "recordValue",
                                  required: true,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-checkbox", {
                                attrs: {
                                  checked: false,
                                  form: _vm.insurancePOStreet,
                                  "hide-label": true,
                                  "override-label": "",
                                  property: "override",
                                  "unchecked-value": "0",
                                  value: "1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [_c("span", [_vm._v(" ")])]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3280651264
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _vm._v("Postleitzahl der Versicherungsfiliale"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOZipCity,
                                  "hide-label": true,
                                  property: "serviceValue",
                                  required: false,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOZipCity,
                                  "hide-label": true,
                                  property: "recordValue",
                                  required: true,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-checkbox", {
                                attrs: {
                                  checked: false,
                                  form: _vm.insurancePOZipCity,
                                  "hide-label": true,
                                  "override-label": "",
                                  property: "override",
                                  "unchecked-value": "0",
                                  value: "1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [_c("span", [_vm._v(" ")])]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3280651264
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [_vm._v("Ort der Versicherungsfiliale")]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOCity,
                                  "hide-label": true,
                                  property: "serviceValue",
                                  required: false,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOCity,
                                  "hide-label": true,
                                  property: "recordValue",
                                  required: true,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-checkbox", {
                                attrs: {
                                  checked: false,
                                  form: _vm.insurancePOCity,
                                  "hide-label": true,
                                  "override-label": "",
                                  property: "override",
                                  "unchecked-value": "0",
                                  value: "1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [_c("span", [_vm._v(" ")])]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3280651264
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _vm._v("Ansprechpartner der Versicherungsfiliale"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOClerk,
                                  "hide-label": true,
                                  property: "serviceValue",
                                  required: false,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOClerk,
                                  "hide-label": true,
                                  property: "recordValue",
                                  required: true,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-checkbox", {
                                attrs: {
                                  checked: false,
                                  form: _vm.insurancePOClerk,
                                  "hide-label": true,
                                  "override-label": "",
                                  property: "override",
                                  "unchecked-value": "0",
                                  value: "1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [_c("span", [_vm._v(" ")])]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3280651264
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _vm._v("Telefonnummer der Versicherungsfiliale"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOTelephoneNo,
                                  "hide-label": true,
                                  property: "serviceValue",
                                  required: false,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOTelephoneNo,
                                  "hide-label": true,
                                  property: "recordValue",
                                  required: true,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-checkbox", {
                                attrs: {
                                  checked: false,
                                  form: _vm.insurancePOTelephoneNo,
                                  "hide-label": true,
                                  "override-label": "",
                                  property: "override",
                                  "unchecked-value": "0",
                                  value: "1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [_c("span", [_vm._v(" ")])]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3280651264
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _vm._v("Faxnummer der Versicherungsfiliale"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOFaxNo,
                                  "hide-label": true,
                                  property: "serviceValue",
                                  required: false,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOFaxNo,
                                  "hide-label": true,
                                  property: "recordValue",
                                  required: true,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-checkbox", {
                                attrs: {
                                  checked: false,
                                  form: _vm.insurancePOFaxNo,
                                  "hide-label": true,
                                  "override-label": "",
                                  property: "override",
                                  "unchecked-value": "0",
                                  value: "1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [_c("span", [_vm._v(" ")])]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3280651264
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _vm._v("Email-Adresse der Versicherungsfiliale"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOEMail,
                                  "hide-label": true,
                                  property: "serviceValue",
                                  required: false,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-input", {
                                staticClass: "info-card-element",
                                attrs: {
                                  form: _vm.insurancePOEMail,
                                  "hide-label": true,
                                  property: "recordValue",
                                  required: true,
                                  type: "text",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("csp-form-group-checkbox", {
                                attrs: {
                                  checked: false,
                                  form: _vm.insurancePOEMail,
                                  "hide-label": true,
                                  "override-label": "",
                                  property: "override",
                                  "unchecked-value": "0",
                                  value: "1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [_c("span", [_vm._v(" ")])]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3280651264
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            on: {
                              click: function ($event) {
                                _vm.isModalOpen = false
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    Abbrechen\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: { click: _vm.sendForm },
                          },
                          [
                            _vm.isUpdating
                              ? _c("span", {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: {
                                    "aria-hidden": "true",
                                    role: "status",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n                    Speichern\n                "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }